import CityPageTemplate from "../city-template/CityPageTemplate";
import { hanoverConfig } from "./data";

export default function HanoverPage() {
  return <CityPageTemplate config={hanoverConfig} />;
}